import axios from 'axios';
import AxiosConfiguration from '@/classes/AxiosConfiguration';
import {
  DocumentToStoreModel,
  DocumentToStoreViewModel,
  DocumentToStoreSearchModel,
  DocumentToStoreUpdateModel
} from '@/types';
import { BaseModel } from '@/types/models/BaseModel';

const DocumentToStoreApiUrl = 'DocumentToStore';

export const DocumentToStoreService = {
  async getDocumentToStoreAsync(sourceCabinetId: string, sourceDocumentId: number): Promise<DocumentToStoreModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(
      `${DocumentToStoreApiUrl}/${sourceCabinetId}/${sourceDocumentId}`
    );
    return response.data;
  },
  async getDocumentToStoreViewAsync(
    documentToStoreSearchModel: DocumentToStoreSearchModel
  ): Promise<DocumentToStoreViewModel> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(DocumentToStoreApiUrl, {
      params: {
        SourceCabinetId: documentToStoreSearchModel.sourceCabinetId,
        SourceDocumentId: documentToStoreSearchModel.sourceDocumentId,
        TargetDocumentTypeId: documentToStoreSearchModel.targetDocumentTypeId
      }
    });
    return response.data;
  },
  async storeUpdateDocumentAsync(
    sourceCabinetId: string,
    sourceDocumentId: number,
    documentToStoreUpdateModel: DocumentToStoreUpdateModel
  ): Promise<BaseModel> {
    const response =
      await axios.put(`${DocumentToStoreApiUrl}/${sourceCabinetId}/${sourceDocumentId}`, documentToStoreUpdateModel);
    return response.data;
  }
};
